import { memo } from 'react';
// import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg'
import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_Path
        d="M8 0.5C3.875 0.5 0.5 3.875 0.5 8C0.5 12.125 3.875 15.5 8 15.5C12.125 15.5 15.5 12.125 15.5 8C15.5 3.875 12.125 0.5 8 0.5ZM6.5 11.75L2.75 8L3.8075 6.9425L6.5 9.6275L12.1925 3.935L13.25 5L6.5 11.75Z"
        fill="#368665"
      />
    </_Svg>
  );
};
Icon.displayName = 'TickSolid';
const TickSolid = memo(themed(Icon));
export { TickSolid };
